<template>
	<section>

	<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-tag>[{{this.$route.query.type}}]-{{this.$route.query.title}}</el-tag>
				</el-form-item>
				<el-form-item>
					<el-button type="primary"  size="medium" @click="handleAdd">新增发布</el-button>
				</el-form-item>
				<el-form-item>
					
					<el-button type="primary"  size="medium" onclick="window.history.go(-1)">返回</el-button></div>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="infos" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange"
		 style="width: 100%;" :header-row-style="{lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<!--
			<el-table-column type="selection"  min-width="40">
			</el-table-column>
			-->
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			
			<!--
			<el-table-column prop="group_name" label="产品组"  width="80">
			</el-table-column>
			<el-table-column prop="app_name" label="产品"  width="80">
			</el-table-column>
			
			<el-table-column prop="title" label="标题" width="200" >
			</el-table-column>-->
			
			<el-table-column prop="group_name" label="所属分类" width="150" >
			</el-table-column>
			<el-table-column prop="maker_name" label="创建人" width="80" >
			</el-table-column>
			<el-table-column prop="make_date" label="创建时间" width="180" >
			</el-table-column>
			<el-table-column label="操作" min-width="140">
				<template slot-scope="scope">
					<el-button type="primary" size="small"  plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" :disabled="scope.row.sender==null?false:true" plain @click="handleDel(scope.$index, scope.row)">删除</el-button>
					<el-button type="primary" size="small" :disabled="scope.row.sender==null?false:true" plain @click="handleSend(scope.$index, scope.row)">发布确认</el-button>
					<el-button type="danger" size="small" :disabled="scope.row.sender==null?true:false"  plain @click="handleCancel(scope.$index, scope.row)">撤销</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>--></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" size="small" >
			<el-form :model="editForm"    label-width="120px" :rules="editFormRules" ref="editForm">
				<el-form-item label="产品组" prop="app_group">
					<el-select v-model="editForm.app_group"   placeholder="请选择" @change="appGroupChange"  @visible-change="visibleChange"  style="width:400px;">
					<el-option  v-for="(item,index) in appgroups" :key="index"  :label="item.item_name"  :value="item.item_value"> </el-option>
					</el-select>
				</el-form-item>


				<el-form-item label="产品" prop="app_id">
					<el-select v-model="editForm.app_id"   placeholder="请选择" style="width:400px;">
					<el-option  v-for="(item,index) in apps" :key="index"  :label="item.app_name"  :value="item.id"> </el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="所属分类" prop="group_code" >
					<el-select v-model="editForm.group_code" clearable placeholder="请选择"  style="width:400px;">
					<el-option-group    v-for="(group,index) in discoveryGroups"  :key="index"   :label="group.group_name">
						<el-option  v-for="(item,i) in group.children"  :key="i"  :label="item.group_name"  :value="item.group_code"> </el-option>
					</el-option-group>
					</el-select>
				</el-form-item>

				<el-form-item label="定时显示" prop="show_time" >
					<el-date-picker style="width:400px;" 
						v-model="editForm.show_time"
						type="datetime"
						placeholder="选择日期时间"
						value-format="yyyy-MM-dd HH:mm:ss"
						formt="yyyy-MM-dd HH:mm:ss"
						:default-value="new Date()"						
						>
					</el-date-picker>
				</el-form-item>


				<el-form-item label="首页显示设置" >
					<el-switch	v-model="editForm.first_show"	active-text="显示"	inactive-text="不显示" @change="showChange"  >
					</el-switch>
					<el-switch	v-model="editForm.first_top" :disabled="editForm.first_show==true?false:true" active-text="置顶"	inactive-text="不置顶">
					</el-switch>
                </el-form-item>

			    <el-form-item label="所属类显示设置" >
					<el-switch	v-model="editForm.show_type"	active-text="推荐区"	inactive-text="非推荐区">
					</el-switch>
					<el-switch	v-model="editForm.top"	active-text="置顶"	inactive-text="不置顶">
					</el-switch>
                </el-form-item>
				
		
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getReleaseListPage,addRelease,editRelease, removeRelease,batchRemoveRelease,getAppGroup,getApp,getReleaseBase,discoveryRelease,discoveryUnRelease } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
 
	export default {
		data() {
			return {
				filters: {
					title: ''
				},	
				appgroups:[],
				apps:[],
				discoveryGroups:[],						
				infos: [],
				total: 0,
				pageSize:20,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible:false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					app_group: [
						{ required: true, message: '请选择产品组', trigger: 'change' }
					],
					app_id:[ {  required: true, message: '请选择产品', trigger: 'change' }]
					
				},							
				//编辑界面数据
				editForm: {
					id: 0,						
					group_code:'1',
					first_show:false,
					first_top:false,
					show_type:false,
					top:false,					
					app_group:'',
					app_id:'',					
					push_id:0,
					show_time: ''
				},				
				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
 		    handleSizeChange(val) {
				this.pageSize=val;                 
				this.getInfos();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfos();
			},           


			visibleChange(val)
			  {
                 if(val)
				 {
                      this.selectchangeflag=1;
				 }else{
                       this.selectchangeflag=0;
				 }
			  },
			removeTag(val)
			  {
                  this.selectchangeflag=1;
			  },
			appGroupChange(val)
				{   
					if (this.selectchangeflag==0) return;
					this.editForm.app_id='';
					if (val==''  ) return;				   				
				    this.getApp(val);                
					
					
				   
				},
			showChange(val)
				{                   
				   
				   if (val==false)
				   { 
					   this.editForm.first_top=false;	
				   }						   				
				   
				   
				},

			getApp(val){
					this.$http.jsonp(getApp,{params: {CurrentUserID:CurrentUserID,Session:Session,appGroup:val}}).then(
						function(res){                         
							if (res.data.result_code==200)
							{						
								this.apps=res.data.apps;								
							    
								
							}
							else{                           
								this.$message({
								message:'获取产品错误',
								type: 'error'
								});
							}					

						},
						function(res){
							this.$message({
									message:'获取产品错误',
									type: 'error'
									}
							);
								
						}
					);

				},

		   getAppGroup(){
             	this.$http.jsonp(getAppGroup,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
						if (res.data.result_code==200)
						{						
							this.appgroups=res.data.appgroups;					
						}
						else{                           
							this.$message({
							message:'获取产品组错误',
							type: 'error'
							});
						}				

					},
					function(res)
					{
						this.$message({
								message:'获取产品组错误',
								type: 'error'
								}
						);
						
					}
				);
			},
			getBase(){
             	 this.$http.jsonp(getReleaseBase,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
					if (res.data.result_code==200)
					{						
						
						this.discoveryGroups=res.data.discoveryGroups;	
												
					}
					else{                           
						this.$message({
						message:'获取基础信息错误',
						type: 'error'
						});
					}			

					},
					function(res)
					{
						this.$message({
								message:'获取基础信息错误',
								type: 'error'
								});
						
					});


			},
			getInfos() {
				let para = {
					push_id:this.$route.query.push_id,
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					title: this.filters.title,					
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getReleaseListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.infolist.total;
					         this.infos = res.data.infolist.infos;
					         this.listLoading = false;
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )

			},
			//删除
			handleDel: function (index, row) {

				if (row.sender!=null)
				{
                    this.$message({
                                message:'已确认发布，不能删除！',
                                type: 'warning'
                              });
					return;

				}
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };


                   this.$http.jsonp(removeRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
		    //发布
			handleSend: function (index, row) {
				if (row.sender!=null)
				{
                    this.$message({
                                message:'已发布！',
                                type: 'warning'
                              });
				     return;
				}

				this.$confirm('确认发布吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };

                   this.$http.jsonp(discoveryRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '发布成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//撤销发布
			handleCancel: function (index, row) {
				if (row.sender==null)
				{
                    this.$message({
                                message:'未发布，不能撤销！',
                                type: 'warning'
                              });
				     return;
				}

				this.$confirm('确认撤销吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };

                   this.$http.jsonp(discoveryUnRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '撤销成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:res.data.error,
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;

				
				this.selectchangeflag=0;
				
				this.editForm = Object.assign({}, row); 				

				this.editForm.top=this.editForm.top>0?true:false; 
				this.editForm.show_type=this.editForm.show_type>0?true:false; 	
                this.editForm.first_show=this.editForm.first_show>0?true:false;
				this.editForm.first_top=this.editForm.first_top>0?true:false;		

				this.getApp(this.editForm.app_group);
				

				this.editFormVisible = true;
      			
				
			},
			getNowFormatDate: function () {
				var date = new Date();				
				var seperator1 = "-";
				var seperator2 = ":";
				var year = date.getFullYear();				
				var month = date.getMonth() + 1;
				var strDate = date.getDate();
				if (month >= 1 && month <= 9) {
					month = "0" + month;
				}
				if (strDate >= 0 && strDate <= 9) {
					strDate = "0" + strDate;
				}
				var currentdate = year + seperator1 + month + seperator1 + strDate
						+ " " + date.getHours() + seperator2 + date.getMinutes()
						+ seperator2 + date.getSeconds();						
				return currentdate;
			},
			//显示新增界面
			handleAdd: function () {				
				this.formStatus=0;				
				this.editFormVisible = true;

				this.editForm = {
					id: 0,									
					group_code:'1',
					first_show:false,
					first_top:false,
					show_type:false,
					top:false,					
					app_group:'',
					app_id:'',					
					push_id:this.$route.query.push_id,
					show_time: this.getNowFormatDate()
				};
				
               if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
			},
			//编辑
			editSubmit: function () {

				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							if (this.editForm.open_type!='01')
							{
								this.editForm.url='';
							} 
							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;
							let infoUrl=addRelease;			  
							if (this.formStatus==1)
							{
								infoUrl=editRelease;
							}
                			//this.$http.jsonp(infoUrl, {params: para}).then(
							this.$http.post(infoUrl, para,{emulateJSON:false}).then(
							function(res){                         
								if (res.data.result_code==200)
								{		
									// this.$refs['editForm'].resetFields();	
									this.editForm = {
										id: 0,									
										group_code:'',
										first_show:false,
										first_top:false,
										show_type:false,
										top:false,					
										app_group:'',
										app_id:'',					
										push_id:this.$route.query.push_id         
									};		
												
										this.editLoading = false;								
										this.$message({
											message: '提交成功',
											type: 'success'
										});
										

										if (this.formStatus==1)
										{
										this.editFormVisible = false;
										}
										this.getInfos();
									
								}
								else{                           
									this.editLoading = false;
									if (res.data.result_code==911)
									{
										this.$router.push({ path: "/login"});
										return;
									}

									if (res.data.result_code==600)
									{
											this.$message({
												message:res.data.error,
												type: 'error'
											});
										return;
									}
									if  (res.data.result_code==912)
									{
									this.$message({
										message:'没有新增权限',
										type: 'error'
									});
									return;
									}
									if  (res.data.result_code==913)
									{
									this.$message({
										message:'没有编辑权限',
										type: 'error'
									});
									return;
									}
								}
							},
							function(res)
							{
									this.$message({
											message:'接口访问失败',
											type: 'error'
										});
										this.editLoading = false;	
								
							})
						});
					}
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getInfos();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };
            

                   this.$http.jsonp(batchRemoveRelease, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			this.getAppGroup();
			this.getBase();
			this.getInfos();	        
			
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// releaselist.vue?47368ff2